export default __webpack_public_path__ + "be49a206b0e5aa9b156b1e7c6fbe294e.svg";